import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import PreLoginContainer from "../../common/preLoginContainer";
import Link from "../../common/link";
import { Field } from "react-final-form";
import { TextInput } from "../../common/fields";
import Form from "../../common/form";
import * as Validations from "../../common/form/validator";
import { RouteConstants } from "../../../constants";
import {
  resetState,
  resetPasswordRequest,
} from "../../../store/slices/authSlice";
import { useEffect, useState } from "react";

const ResetPassword = ({
  action,
  error,
  requesting,
  resetState,
  resetPasswordRequest,
}) => {
  const intl = useIntl();
  const params = useParams();
  const [isPasswordReset, setIsPasswordReset] = useState(false);

  useEffect(() => {
    resetState();
  }, [resetState]);

  useEffect(() => {
    if (action === "reset-password" && !requesting && !error) {
      setIsPasswordReset(true);
    }
  }, [action, requesting, error, setIsPasswordReset]);

  return (
    <PreLoginContainer>
      <div className="title text-center">
        {intl.formatMessage({ id: "reset_password" })}
      </div>
      {(!isPasswordReset && (
        <>
          <div className="tag-line text-muted">
            {intl.formatMessage({ id: "reset_password_message" })}
          </div>
          <Form
            requesting={action === "reset-password" && requesting}
            fullWidthButtons
            submitBtn={{
              label: intl.formatMessage({ id: "reset_password" }),
              icon: "pi-arrow-right",
              onClick: (values) =>
                resetPasswordRequest({
                  token: params.token,
                  password: values.newPassword,
                }),
            }}
          >
            <div className="flex flex-column gap-2 mt-4">
              <Field
                name="newPassword"
                component={TextInput}
                showPasswordFeedback
                type="password"
                placeholder={intl.formatMessage(
                  { id: "dynamic_password" },
                  { label: "New" }
                )}
                required
                validate={Validations.composeValidators(Validations.required)}
              />
              <Field
                name="confPassword"
                component={TextInput}
                type="password"
                showPasswordFeedback
                placeholder={intl.formatMessage(
                  { id: "dynamic_password" },
                  { label: "Confirm New" }
                )}
                required
                validate={Validations.composeValidators(
                  Validations.required,
                  Validations.checkConfirmPassword
                )}
              />
            </div>
            {(error && !requesting && action === "reset-password" && (
              <div className="error-message">
                {intl.formatMessage({
                  id: (error?.response || "unknown_error").toLowerCase(),
                })}
              </div>
            )) ||
              null}
          </Form>
        </>
      )) || (
        <div className="tag-line text-muted">
          {intl.formatMessage({ id: "reset_success_message" })}
        </div>
      )}
      <div className="text-center mt-1">
        <Link to={RouteConstants.APP_ROUTE_LOGIN}>
          {intl.formatMessage({ id: "back_to_login" })}
        </Link>
      </div>
    </PreLoginContainer>
  );
};

const mapStateToProps = (state) => ({
  requesting: state.auth.requesting,
  error: state.auth.error,
  action: state.auth.action,
});

const mapDispatchToProps = (dispatch) => ({
  resetPasswordRequest: (data) => dispatch(resetPasswordRequest(data)),
  resetState: () => dispatch(resetState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
